import { env } from '$env/dynamic/public';
import type { Glossary } from '$lib/types/glossary';

export async function getPosts(
  fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>,
  pageIndex: number
) {
  const response = await fetch(
    `${env.PUBLIC_WORDPRESS_BASE_URL}wp/v2/posts?_fields[]=slug&_fields[]=title&categories=3,4,16&per_page=10&page=${pageIndex}`
  );

  return {
    data: await response.json(),
    headers: response.headers
  };
}

export async function getRelatedPosts(
  fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>,
  id: any,
  password: string | null
) {
  let url = `${env.PUBLIC_WORDPRESS_BASE_URL}yarpp/v1/related/${id}?_embed=1`;
  if (password !== null) {
    url += `&password=${password}`;
  }
  const response = await fetch(url);
  return await response.json();
}

export async function getPostByName(
  fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>,
  slug: string,
  password: string | null
) {
  const fields = getQueryStringFields([
    'id',
    'excerpt',
    'content',
    'title',
    'author',
    'date',
    'yoast_head_json'
  ]);
  let url = `${env.PUBLIC_WORDPRESS_BASE_URL}wp/v2/posts?slug=${slug}&${fields}`;
  if (password !== null) {
    url += `&password=${password}`;
  }
  const response = await fetch(url);
  return response.json();
}

export async function getUser(
  fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>,
  id: any
) {
  const url = `${env.PUBLIC_WORDPRESS_BASE_URL}wp/v2/users/${id}?${getQueryStringFields(['name'])}`;
  const response = await fetch(url);
  return response.json();
}

export async function getUsers(
  fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>
) {
  const url = `${env.PUBLIC_WORDPRESS_BASE_URL}wp/v2/users?${getQueryStringFields(['name', 'acf', 'avatar_urls'])}`;
  const response = await fetch(url);
  return response.json();
}

export function getQueryStringFields(fields: string[]): string {
  let result = `_fields[]=${fields[0]}`;

  for (let i = 1; i < fields.length; i++) {
    result += `&_fields[]=${fields[i]}`;
  }

  return result;
}

export async function getTags(
  fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>
) {
  const url = `${env.PUBLIC_WORDPRESS_BASE_URL}wp/v2/tags?per_page=100&${getQueryStringFields(['id', 'name', 'count'])}&hide_empty=true`;
  const response = await fetch(url);
  return response.json();
}

export async function getNews(
  fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>
) {
  let url = `${env.PUBLIC_WORDPRESS_BASE_URL}wp/v2/posts?page=1&per_page=100&categories=23&${getQueryStringFields(['content', 'title', 'date', 'featured_media'])}`;
  const response = await fetch(url);
  return response.json();
}

export async function getFeaturedImage(
  fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>,
  id: any
) {
  const url = `${env.PUBLIC_WORDPRESS_BASE_URL}wp/v2/media/${id}?${getQueryStringFields(['media_details'])}`;
  const response = await fetch(url);
  return response.json();
}

export async function getGlossaryByName(
  fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>,
  name: string
): Promise<Glossary> {
  const fields = getQueryStringFields(['title', 'content', 'yoast_head_json']);
  const url = `${env.PUBLIC_WORDPRESS_BASE_URL}wp/v2/glossary?slug=${name}&${fields}`;
  const response = await fetch(url);
  const data = await response.json();

  return data[0];
}

export function humanizeCategory(category: number): string | null {
  switch (category) {
    case 16:
      return 'Historical Milestone';
    case 3:
      return 'Science Capsule';
    case 4:
      return 'Technical Capsule';
    default:
      return null;
  }
}
